import { isInSelection, toggleSelection } from '../../selection/utils.js';

const template = document.querySelector('#resultat-template');

/**
 * Classe "abstraite" d'un résultat
 */
export class Resultat {
  element;
  features;
  index = 0;

  constructor(clusterFeature) {
    this.clusterFeature = clusterFeature;
    this.features = this.clusterFeature.get('features');
    this.isCluster = this.features.length > 1;
  }

  geometry() {
    return this.clusterFeature.getGeometry();
  }

  id() {
    // Même avec 1 seul élément, les clusters sont des features différentes à différents niveau de zoom.
    // On fallback sur l'identifiant feature vectorielle représentée
    return this.isCluster
      ? this.clusterFeature.get('hashcode')
      : this.clusterFeature.get('features')[0].ol_uid;
  }

  getFeatureId() {
    return this.features[this.index].get('id');
  }
  isSelected() {
    return this.clusterFeature.get('selected');
  }

  /** Met à jour la feature liée au résultat */
  maybeUpdateFeature(feature) {
    if (feature !== this.clusterFeature) {
      const isSelected = this.clusterFeature.get('selected');
      this.clusterFeature = feature;
      this.clusterFeature.set('selected', isSelected);
    }
  }

  remove() {
    this.element.remove();
    this.element = null;
  }

  renderResultat(data) {
    const el = template.content.firstElementChild.cloneNode(true);
    if (data.selected) el.classList.add('selected');

    this.updateResultatInfo(el, data);

    el.dataset.id = this.id();
    this.element = el;
    return el;
  }

  render() {
    if (this.isCluster) {
      return this.renderCluster();
    }
    const feature = this.features[0];
    const el = this.renderResultat(feature.getProperties());
    el.querySelector('.pagination').remove();
    return el;
  }

  renderCluster() {
    const data = this.features[this.index].getProperties();
    data.selected = this.clusterFeature.selected;

    const el = this.renderResultat(data);
    el.querySelector('.pages').textContent = `${this.index + 1} / ${
      this.features.length
    }`;

    el.classList.remove('non-visible');
    this.element = el;
    return el;
  }

  toggleSelected() {
    this.element.classList.toggle('selected');
    this.clusterFeature.set('selected', !this.clusterFeature.get('selected'));
  }

  unselect() {
    this.element.classList.remove('selected');
    this.clusterFeature.set('selected', false);
  }

  previous() {
    const idx = this.index - 1;
    this.index = idx < 0 ? this.features.length - 1 : idx;
    this.updateElement();
  }

  next() {
    this.index = (this.index + 1) % this.features.length;
    this.updateElement();
  }

  updateElement() {
    const data = this.features[this.index].getProperties();
    this.updateResultatInfo(this.element, data);
    this.updatePagination(this.element);
  }

  updateResultatInfo(el, data) {
    if (data.urlImg) {
      el.querySelector('img').src = data.urlImg;
      el.querySelector('.image-indispo').style = 'display: none;';
    } else {
      el.querySelector('img').style = 'display: none;';
    }
    el.querySelector('.titre').textContent = data.title;
    el.querySelector('.localisation').textContent = data.localisations;
    el.querySelector('.lien-dossier').href = data.link;
    el.querySelector('.telecharger-bouton').href = data.linkPdf;

    const enSelection = isInSelection('dossier', data.id);
    el.querySelector('.selection-bouton').classList.toggle(
      'en-selection',
      enSelection,
    );
    if (data.problemeDiffusion) {
      let divProblemeDiffusion = document.createElement('div');
      divProblemeDiffusion.classList = 'illustration-probleme-diffusion';
      divProblemeDiffusion.innerHTML = data.problemeDiffusion;
      el.querySelector('.image-indispo').append(divProblemeDiffusion);
    }
  }

  updatePagination(el) {
    el.querySelector('.pages').textContent = `${this.index + 1} / ${
      this.features.length
    }`;
  }

  toggleSelection() {
    const estAjoute = toggleSelection('dossier', this.getFeatureId());
    this.element
      .querySelector('.selection-bouton')
      .classList.toggle('en-selection', estAjoute);
  }
}
